const BLACK = '\x1b[30m';
const RED = '\x1b[31m';
const GREEN = '\x1b[32m';
const YELLOW = '\x1b[33m';
const BLUE = '\x1b[34m';
const MAGENTA = '\x1b[35m';
const CYAN = '\x1b[36m';
const WHITE = '\x1b[37m';
const DEFAULT = '\x1b[39m';

const BG_BLACK = '\x1b[40m';
const BG_RED = '\x1b[41m';
const BG_GREEN = '\x1b[42m';
const BG_YELLOW = '\x1b[43m';
const BG_BLUE = '\x1b[44m';
const BG_MAGENTA = '\x1b[45m';
const BG_CYAN = '\x1b[46m';
const BG_WHITE = '\x1b[47m';
const BG_DEFAULT = '\x1b[49m';

import { environment } from '@environments/environment';

const RESET = '\x1b[0m';

export class PrettyConsole {
  /**
   * This does not always work BUT it's better than nothing
   * @return file: file where the message was called
   * @return line: Line where this was called
   */
  private static _get_file_and_line_maybe() {
    const err = new Error();
    const stack = (err.stack || '').split('\n');
    const caller = stack[3];
    const match = caller.match(/at (?<FUNCION>.*) /);
    const func = match?.groups?.['FUNCION'];
    return { func };
  }

  /**
   * Shows a success message in the console if the dbg environment is set
   * @param msg
   */
  public static SUCCESS(msg: string) {
    if (environment.dbg === true) {
      const { func } = this._get_file_and_line_maybe();
      console.log(`${GREEN} [SUCCESS] -- ${func} ->  ${msg} ${RESET}\n`);
    }
  }

  /**
   * Shows a info message in the console if the dbg environment is set
   * @param msg
   */
  public static INFO(msg: string) {
    if (environment.dbg === true) {
      const { func } = this._get_file_and_line_maybe();
      console.log(`${CYAN} [INFO] -- ${func} ->  ${msg} ${RESET}\n`);
    }
  }

  /**
   * Shows a warning message in the console if the dbg environment is set
   * @param msg
   */
  public static WARNING(msg: string) {
    if (environment.dbg === true) {
      const { func } = this._get_file_and_line_maybe();
      console.log(`${YELLOW} [WARNING] -- ${func} ->  ${msg} ${RESET}\n`);
    }
  }

  /**
   * Shows a error message in the console if the dbg environment is set
   * @param msg
   */
  public static ERROR(msg: string) {
    if (environment.dbg === true) {
      const { func } = this._get_file_and_line_maybe();
      console.log(`${RED} [ERROR] -- ${func} ->  ${msg} ${RESET}\n`);
    }
  }
}
